export default __webpack_public_path__ + "static/media/medical.57699cb5.jpg";